module.exports = __webpack_public_path__ + "media/notification-sound.90f36af5.mp3";